<template>
  <div
    class="rich-textarea"
    :class="{ '-empty': !modelValue, '-disabled': disabled }"
    :contenteditable="disabled ? 'false' : 'plaintext-only'"
    role="textbox"
    aria-multiline="true"
    :aria-disabled="disabled ? 'true' : undefined"
    :aria-placeholder="placeholder || undefined"
    :aria-label="placeholder || undefined"
    :data-placeholder="placeholder"
    spellcheck="true"
    @input="onInput"
    @blur="onBlur"
    @copy="onCopy"
    @cut="onCut"
    @dragstart="onDragStart"
    @compositionstart="composing = true"
    @compositionend="onCompositionEnd"
  />
</template>

<script src="./rich_textarea.js"></script>

<style lang="scss">
@use "../../mixins";

.rich-textarea {
  position: relative;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  cursor: text;
  outline: none;

  /* out of the line, so the caret starts at its beginning, not after it;
     without offsets it stays where the text would start */
  &.-empty::before {
    content: attr(data-placeholder);
    position: absolute;
    color: var(--textFaint);
    pointer-events: none;
  }

  &.-disabled {
    cursor: not-allowed;
  }
}

/* a mentioned user; also in EmojiInput's hidden caret copy. At most as
   wide as the field: a long name ends in "…" */
.rich-mention {
  @include mixins.mention-pill;

  max-width: 100%;
  box-sizing: border-box;
  user-select: all;
  cursor: default;
}

.rich-mention-avatar {
  @include mixins.mention-pill-avatar;

  flex: none;
}

.rich-mention-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* also used in EmojiInput's hidden caret copy, which must match */
.rich-emoji {
  width: 1.4em;
  height: 1.4em;
  object-fit: contain;
  vertical-align: -0.3em;
}
</style>
